export const APP_LIMITS__SET_LIMIT_MESSAGE = 'APP_LIMITS__SET_LIMIT_MESSAGE';
export const APP_LIMITS__RESET_LIMIT_MESSAGE = 'APP_LIMITS__RESET_LIMIT_MESSAGE';
